module.exports = __webpack_public_path__ + "media/images/emblems/Henggart-blazon-42374b15a64df31f8bb861bf977cc6e8.svg";